import React from "react";
import logo from "../assets/logo.png"
const WriteUps = () => {
  return (
    <section className="bg-[#F9FAFB] py-16 px-4 sm:px-6 lg:px-12">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
        
        {/* LEFT SIDE (IMAGE) */}
        <div className="relative">
          <img
            src={logo}
            alt="Founder"
            className="w-full h-[450px] object-cover rounded-3xl shadow-lg"
          />

          {/* Overlay Card */}
          <div className="absolute bottom-6 left-6 bg-white/90 backdrop-blur-md p-4 rounded-xl shadow-md">
            <p className="font-semibold text-gray-900">Esther</p>
            <p className="text-sm text-gray-600">
              Founder, Queen Esther Impact Foundation
            </p>
          </div>
        </div>

        {/* RIGHT SIDE (TEXT) */}
        <div>
          {/* Heading */}
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 leading-tight mb-6">
            A Message from the Founder
          </h2>

          {/* Highlight Quote */}
          <p className="text-lg italic text-gray-600 border-l-4 border-pink-500 pl-4 mb-6">
            “A vision birthed in prayer, driven by love, and committed to restoring hope.”
          </p>

          {/* Content */}
          <div className="space-y-5 text-gray-700 leading-7">
            <p>
              Dear Friends,
            </p>

            <p>
              Welcome to <strong>Queen Esther Impact Foundation</strong>.
            </p>

            <p>
              This vision was birthed in a place of prayer and deep intimacy
              with God. It reflects His heart for humanity, His way of reaching
              people, restoring hope, saving lives, and transforming communities
              through love.
            </p>

            <p>
              We are a faith-based organization created to serve everyone —
              women and men, children, families, the overlooked, the struggling,
              and anyone in need of compassion and support.
            </p>

            <p>
              Through outreach, empowerment, education, advocacy, and
              rehabilitation, we meet people where they are and walk alongside
              them toward healing and renewed hope.
            </p>

            <p>
              This mission is deeply personal to me. I have seen how faith,
              consistency, and kindness can transform lives — and this
              foundation exists to be a vessel for that transformation.
            </p>

            <p>
              This is more than an organization — it is a movement of compassion,
              faith, and obedience to God’s call.
            </p>

            <p>
              I warmly invite you to join us through prayer, volunteering,
              partnership, or giving. Together, we can become instruments of
              hope.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="mt-8 flex flex-wrap gap-4">
            <button className="bg-[#6A0DAD] hover:bg-[#5F0F99] text-white px-6 py-3 rounded-lg font-medium transition">
              Partner With Us
            </button>

            <button className="border border-[#6A0DAD]  px-6 py-3 rounded-lg font-medium hover:bg-white text-[#6A0DAD] transition">
              Learn More
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WriteUps;